$(() => {
	if (window?.Vue) {
		function debounce(callback, wait, immediate = false) {
			let timeout = null;

			return function () {
				const callNow = immediate && !timeout;
				const next = () => callback.apply(this, arguments);

				clearTimeout(timeout);
				timeout = setTimeout(next, wait);

				if (callNow) {
					next();
				}
			};
		}

		const queryParams = new Proxy(new URLSearchParams(window.location.search), {
			get: (searchParams, prop) => searchParams.getAll(prop),
		});

		function findTermById(id, collection) {
			let found;

			for (const entry of collection) {
				if (found) {
					return found;
				} else if (entry?.terms && Array.isArray(entry.terms) && entry.terms.length) {
					found = findTermById(id, entry.terms);
				} else if (entry.id === id) {
					return entry;
				} else if (
					entry?.children &&
					Array.isArray(entry.children) &&
					entry.children.length
				) {
					found = findTermById(id, entry.children);
				}
			}

			return found;
		}

		function idsToTags(ids, allTags) {
			return ids.map((id) => findTermById(id, allTags));
		}

		const { createApp } = Vue;

		const globalInitOpen = Vue.reactive({
			initOpen: false,
			setInitOpen(val) {
				this.initOpen = !!val;
			},
		});

		const store = Vue.reactive({
			selectedTags: [],
			updateSelectedTags(arrayOfIds, allTags) {
				if (!Array.isArray(arrayOfIds) || !allTags || !allTags.length) {
					return;
				}
				const selectedTagsCollection = idsToTags(arrayOfIds, allTags);
				this.selectedTags = selectedTagsCollection;
			},
			addToSelected(newItem) {
				const isSelected = this.selectedTags.find((item) => {
					return item.id === newItem.id;
				});

				if (!isSelected) {
					this.selectedTags.push(newItem);
				}
			},
			removeFromSelected(id) {
				this.selectedTags = this.selectedTags.filter((item) => {
					return item.id !== id;
				});
			},
		});

		const TreeItem = {
			name: "tree-item",
			template: "#tree-item",
			props: {
				item: Object,
				children: [Object],
				isTaxonomy: {
					type: Boolean,
					default: false,
				},
				isEnglish: {
					type: Boolean,
					default: false,
				},
				initOpen: {
					type: Boolean,
					default: false,
				},
			},
			data() {
				return {
					globalInitOpen,
					store,
					isCollapsed: undefined,
				};
			},
			watch: {
				globalInitOpen: {
					handler() {
						this.isCollapsed = this.globalInitOpen.initOpen;
					},
					deep: true,
				},
			},
			methods: {
				toggleCollapse() {
					if (this.children && this.children.length) {
						this.isCollapsed = !this.isCollapsed;
					}
				},
			},
			computed: {
				isSelected() {
					return !!this.store.selectedTags.find((tag) => tag.id === this.item.id);
				},
			},
		};

		const AppComponent = {
			name: "app",
			components: {
				TreeItem,
			},
			mounted() {
				this.fetchTaxonomies().then((res) => {
					const allTags = res?.data ?? [];
					const selectedIDs = queryParams["advanced-tags[]"]
						.map((val) => Number.parseInt(val))
						.filter(Number.isFinite);

					this.store.updateSelectedTags(selectedIDs, allTags);
				});
			},
			data() {
				return {
					globalInitOpen,
					store,
					isLoading: false,
					allTaxonomies: [],
					isCollapsed: false,
					hasFocus: false,
					searchValue: "",
				};
			},
			methods: {
				fetchTaxonomies(search = "") {
					this.isLoading = true;
					return fetch(`/wp-json/laravel/v1/fetch-tags?type=advanced&name=${search}`)
						.then((res) => res.json())
						.then((res) => {
							this.globalInitOpen.setInitOpen(search.trim().length > 0);
							this.allTaxonomies = res.data;
							return res;
						})
						.catch((error) => console.log(error))
						.finally(() => {
							this.isLoading = false;
						});
				},
				debounceInput: debounce(function (e) {
					this.searchValue = e.target.value;
				}, 500),
				toggleTreeCollapse() {
					this.isCollapsed = !this.isCollapsed;
				},
				setFocus(val) {
					this.hasFocus = !!val;
					if (val) this.isCollapsed = true;
				},
			},
			watch: {
				searchValue(newValue) {
					this.fetchTaxonomies(newValue);
				},
			},
		};

		createApp(AppComponent).mount("#advanced-tags");
	}
});
